export default __webpack_public_path__ + "static/media/stress.dc57d8f9.svg";